var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.enabled)?_c(_setup.WujieVue,{staticClass:"pa-relative pa-z-[9999]",attrs:{"name":_setup.MICRO_NAME,"url":_setup.MICRO_URL,"props":_setup.wujieProps,"plugins":[_setup.InstanceofPlugin()]}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }